// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"556":"d2f2bac8","787":"26a9bb17","920":"51dfc4b0"}[chunkId] + ".chunk.js";
};